import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpUtilsService } from '../shared/http-utils/http-utils.service';
import { ItemResponseWrapper, ListResponseWrapper } from '../shared/http.types';
import { IPageablePayload } from '../shared/common.types';
import { Organization, OrganizationMappingResponse } from '../organization/shared/organization.types';
import { ICreateAccountRaw } from '../shared/account/create-account.helper';

export interface IGetOrganizationsParams extends Partial<IPageablePayload> {
}

@Injectable({ providedIn: 'root' })
export class AdminOrganizationHttpService {

  private readonly http: HttpClient;
  private readonly httpUtils: HttpUtilsService;

  constructor() {
    this.http = inject(HttpClient);
    this.httpUtils = inject(HttpUtilsService);
  }

  public getOrganizations({ page =  1, pageSize =  10 }: IGetOrganizationsParams = {}): Observable<Organization.Organization[]> {
    return this.http.get<ListResponseWrapper<Organization.Organization>>(
      `${environment.backendBaseUrl}/admin/organization`,
      { params: { page, pageSize } },
    ).pipe(
      map(this.httpUtils.listWrapperResponseMapper)
    );
  }

  public getOrganizationsByAccount(accountId: string, { page =  1, pageSize =  10 }: IGetOrganizationsParams = {}): Observable<OrganizationMappingResponse[]> {
    return this.http.get<ListResponseWrapper<OrganizationMappingResponse>>(
      `${environment.backendBaseUrl}/admin/organization/mapping`,
      { params: { accountId, page, pageSize } },
    ).pipe(
      map(this.httpUtils.listWrapperResponseMapper)
    );
  }

  public getOrganization(id: string): Observable<Organization.Organization> {
    return this.http.get<ItemResponseWrapper<Organization.Organization>>(
      `${environment.backendBaseUrl}/admin/organization/${id}`,
    ).pipe(
      map(this.httpUtils.entityWrapperResponseMapper)
    );
  }

  public createAdvertiser(params: ICreateAccountRaw): Observable<ICreateAccountRaw> {
    const { organizationId, ...value } = params;

    return this.http
      .post<ItemResponseWrapper<ICreateAccountRaw>>(
        `${environment.backendBaseUrl}/admin/organization/${organizationId}/advertiser`,
        value,
      ).pipe(
        map(this.httpUtils.entityWrapperResponseMapper),
        catchError(this.httpUtils.simplifyErrorResponse$),
      )
  }

  public createShop(params: ICreateAccountRaw): Observable<ICreateAccountRaw> {
    const { organizationId, ...value } = params;

    return this.http
      .post<ItemResponseWrapper<ICreateAccountRaw>>(
        `${environment.backendBaseUrl}/admin/organization/${organizationId}/shop`,
        value,
      ).pipe(
        map(this.httpUtils.entityWrapperResponseMapper),
        catchError(this.httpUtils.simplifyErrorResponse$),
      )
  }

}
